



















import { Component, Prop, Vue } from "vue-property-decorator";
import { ClientSetupMaster, ClientSetupOptions } from "@/data/models/ClientSetup";
import { ClientSetupDraft } from "@/utils/ClientSetupDraft";
import { SummarySection, setupSummary } from "@/utils/ClientSetupSummary";
import { formatNumber } from "@/utils/Utils";

@Component
export default class SetupSummaryStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  @Prop({ default: null }) options!: ClientSetupOptions | null;
  @Prop({ default: null }) master!: ClientSetupMaster | null;
  @Prop({ default: false }) busy!: boolean;

  get sections(): SummarySection[] {
    return setupSummary(this.draft, this.options, this.master, (key, values) => this.$t(key, values as never).toString(), formatNumber);
  }
}
